import dayjs from 'dayjs'
import { DateFormat } from 'constants/General'

/**
 * Returns a formatted version of the SingleDate component date value.\
 * If the singleDateValue is not a valid date, the original value is returned.
 * @param {string} singleDateValue the SingleDate component date value in the format DD,MM,YYYY
 * @param {string} format the updated format, default is YYYY-MM-DD
 * @returns {string} the SingleDate component date value in the updated format
 */
export const getFormattedSingleDateValue = (
  singleDateValue: string,
  format = DateFormat.YYYY_MM_DD
): string => {
  if (!singleDateValue) return ''
  const dateValue = dayjs(singleDateValue, 'DD,MM,YYYY')
  if (dateValue.isValid()) {
    return dateValue?.format(format)
  }
  return singleDateValue
}
